module.exports = __webpack_public_path__ + "static/media/cg.1bdb6a1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cg.svg
// module id = 83
// module chunks = 0